import styled, { css } from "styled-components";
import { md, xl } from "styles/breakpoint";
import { theme } from "styles/theme";

const StyledHeader = styled.header`
  & .header__main {
    display: block;
    .header-first {
      max-width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #333;
      height: 40px;
      padding: 0 30px;
      .header__social {
        justify-content: flex-end;
        display: flex;
        width: auto;
        align-items: center;
        position: relative;
        &-list {
          height: 100%;
          width: 100%;
          padding: 0 25px;
          margin-bottom: 0;
          border-left: 1px solid #4b4b4b;
          border-right: 1px solid #4b4b4b;
          position: relative;
          z-index: 11;
          display: flex;
          justify-content: space-between;
          gap: 10px;
          .icon {
            cursor: pointer;
            font-size: 22px;
            color: #cccccc;
            width: 100%;
            transition: 0.4s;
            &:hover {
              color: ${theme.colors.secondary[900]};
              transition: 0.4s;
            }
          }
        }
        &-lang {
          flex-shrink: 0;
          height: 40px;
          margin-left: 10px;
          width: fit-content;
          position: relative;
          z-index: 10;
          display: inline-flex;
          align-items: center;
          .icon {
            color: #cccccc;
          }
          .select {
            position: absolute;
            bottom: -40px;
            display: flex;
            width: max-content;
            height: 100%;
            justify-content: flex-end;
            align-items: center;
            padding: 0;
            border: 1px solid #00b574;
            border-left: 6px solid #00b574;
            padding-right: 14px;
            background: #2f735e;
          }
          .text {
            display: flex;
            align-self: center;
            font-weight: 400;
            font-size: 10px;
            line-height: 12px;
            color: #b8b8b8;
            margin-right: 5px;
          }
        }
      }
    }
    .header-second {
      display: flex;
      justify-content: space-between;
      height: 78px;
      padding: 0 30px;
      background: ${theme.colors.neutrals[900]};
      align-items: center;
      .header {
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .header__search {
          color: white;
          cursor: pointer;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          border: none;
          background: none;
        }
        .header__login {
          text-decoration: none;
          color: white;
          transition: 0.25s;
          border: none;
          background: none;
          cursor: pointer;
          .item {
            img {
              margin-right: 8px;
            }
          }
          &:hover {
            transition: 0.25s;
            color: ${theme.colors.secondary[900]};
          }
          .item {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .header__registration {
          margin: 0 20px;
          padding: 5px 0;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: ${theme.colors.secondary[900]};
          color: ${theme.text.white};
          transition: 0.4s;
          text-decoration: none;
          &:hover {
            color: ${theme.colors.neutrals[50]};
            background: ${theme.colors.secondary[700]};
            transition: 0.4s;
          }
          .item {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 25px;

            .icon {
              padding-right: 10px;
            }
          }
        }
        &.--left {
          .icon {
            height: 50px;
            max-width: 111px;
          }
          .menu {
            display: flex;
            height: 100%;
            padding: 0 50px;
            flex-shrink: 0;
            .button-mobile {
              display: flex;
              justify-self: center;
              align-items: center;
              cursor: pointer;
              position: relative;
              &-menu {
                z-index: 9;
                display: none;
                position: absolute;
                top: 78px;
                left: 0;
                &.--active {
                  display: block;
                }
              }
              span {
                background: ${theme.colors.secondary[900]};
                width: 32px;
                height: 4px;
                border-radius: 4px;
                position: relative;
                &::after {
                  content: "";
                  background: ${theme.colors.secondary[900]};
                  width: 32px;
                  height: 4px;
                  border-radius: 4px;
                  position: absolute;
                  transform: translateY(10px);
                }
                &::before {
                  content: "";
                  background: ${theme.colors.secondary[900]};
                  width: 32px;
                  height: 4px;
                  border-radius: 4px;
                  position: absolute;
                  transform: translateY(-10px);
                }
              }
            }
          }
        }
        &.--right {
          height: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        &.--right-authentication {
          padding: 8px 0;
        }
      }
    }
  }
  .header__mobile {
    overflow: hidden;
    display: none;
    &-top {
      height: 68px;
      width: 100%;
      background: ${theme.colors.neutrals[800]};
      padding: 0 5px;
      .--right {
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-right: 10px;
        .header__registration {
          margin: 0 20px;
          padding: 5px 0;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: ${theme.colors.secondary[900]};
          color: ${theme.text.white};
          transition: 0.4s;
          text-decoration: none;
          &:hover {
            background: ${theme.colors.secondary[700]};
            color: ${theme.colors.neutrals[50]};
            transition: 0.3s;
          }
          .item {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 25px;
          }
        }
        .header__login {
          text-decoration: none;
          color: white;
          transition: all 0.4s ease 0s;
          padding: 0;
          border: none;
          background: none;
          .item {
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.3s;
            .icon {
              font-size: 22px;
              margin-right: 5px;
              color: ${theme.colors.secondary[900]};
            }
            &:hover {
              color: ${theme.colors.secondary[900]};
              transition: 0.3s;
            }
          }
        }
      }
    }
    &-bottom {
      display: flex;
      justify-content: space-between;
      height: 60px;
      width: 100%;
      background: ${theme.colors.neutrals[900]};
      .bottom-menu {
        display: flex;
        height: 100%;
        flex-shrink: 0;
        padding-left: 10px;
        .button-mobile {
          display: flex;
          align-items: center;
          cursor: pointer;
          position: relative;
          padding: 0;
          border: none;
          background: none;
          span {
            background: ${theme.colors.secondary[900]};
            width: 32px;
            height: 4px;
            border-radius: 4px;
            position: relative;
            &::before {
              content: "";
              left: 0;
              background: ${theme.colors.secondary[900]};
              width: 32px;
              height: 4px;
              border-radius: 4px;
              position: absolute;
              transform: translateY(-10px);
            }
            &::after {
              left: 0;
              content: "";
              background: ${theme.colors.secondary[900]};
              width: 32px;
              height: 4px;
              border-radius: 4px;
              position: absolute;
              transform: translateY(10px);
            }
          }
        }
      }
      .bottom-logo {
        height: 100%;
        display: flex;
        align-items: center;
        .icon {
          height: 50px;
          max-width: 111px;
        }
      }
      .bottom-search {
        color: white;
        cursor: pointer;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: none;
        background: none;
      }
    }
  }
  .mobile__wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: -100%;
    z-index: 10;
    width: 100%;
    height: 100%;
    visibility: hidden;
    opacity: 0;
    transition: left 0.4s ease-in, opacity 0.4s ease-in;
    &.--opened {
      left: 0;
      z-index: 100;
      opacity: 1;
      width: 100%;
      visibility: visible;
      background: #222;
    }
    &-content {
      height: 100%;
      width: 100%;
      max-width: 480px;
      padding-bottom: 50px;
      background: linear-gradient(
        -120deg,
        #000 50%,
        ${theme.colors.secondary[900]} 93.83%
      );
      overflow: auto;
      .header {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 45px;
        width: 100%;
        background: ${theme.colors.neutrals[800]};
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        &-close {
          padding: 0;
          border: none;
          background: none;
          position: absolute;
          right: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 45px;
          height: 45px;
          i {
            color: white;
            font-size: 22px;
          }
        }
      }
      .menu-bottom {
        display: flex;
        a {
          color: white;
          text-decoration: none;
          display: flex;
          justify-content: center;
          width: 100%;
          font-size: 12px;
          padding: 5px 7px;
        }
      }
    }
  }
  .search-modal {
    display: none;
    &.--active {
      display: block;
    }
    width: 100vw;
    height: 100vh;
    position: fixed !important;
    z-index: 9999;
    top: 0;
    left: 0;
    display: none;
    &-background {
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background-color: #161616;
      opacity: 70%;
    }
    &-body {
      background-color: #10161e;
      width: 668px;
      position: relative;
      margin: 140px auto;
      border-radius: 10px;
      z-index: 10;
      &-header {
        background-color: #333;
        height: 56px;
        border-radius: 0;
        box-shadow: none;
        display: flex;
        flex-direction: row;
        align-items: center;
        align-content: space-around;
        .search-icon {
          margin: 20px 16px 16px 20px;
        }
        form {
          margin-bottom: 0;
          width: 90%;
          input {
            font-family: "Exo 2", serif;
            font-style: normal;
            font-weight: normal;
            background-color: inherit;
            font-size: 16px;
            line-height: 19px;
            border: none;
            color: white;
            width: 100%;
            :focus {
              outline: 0;
            }
            textarea {
              width: 100%;
              height: 48px;
              font-size: 16px;
              line-height: 30px;
              background-color: #3a3a3a;
              border: 1px solid transparent;
              border-radius: 10px;
              color: #fff;
              padding: 5px 10px;
              box-sizing: border-box;
              transition: border-color 0.2s ease-out;
              text-overflow: ellipsis;
              outline: 0;
            }
          }
        }
        .close-icon {
          cursor: pointer;
          margin-right: 17px;
          width: 25px;
          height: 25px;
          fill: #ccc;
          padding: 0;
          border: none;
          background: none;
        }
      }
    }
  }
  ${xl(css`
    .header__main {
      display: none;
    }
    .header__mobile {
      display: block;
    }
  `)}
  ${md(css`
    .search-modal {
      &-body {
        width: 355px;
      }
    }
    .header__mobile-top {
      padding: unset;
      .header {
        .header__profile {
          .header__profile-info {
            .avt {
              padding: 0 5px;
              .avatar-user {
                display: none;
              }
              .level-user {
                display: block;
              }
            }
          }
          .header__profile-level {
            display: none;
          }
          .header__profile-deposit {
            margin-right: 5px;
          }
        }
        .header__login {
          p {
            display: none;
          }
        }
      }
    }
  `)}
`;
export default StyledHeader;
